module.exports = __webpack_public_path__ + "media/get-started/BoxProduct-f2527aa7.png";